// eslint-disable-next-line unicorn/filename-case
import UAParser from 'ua-parser-js';

export const UAParserService = new UAParser();
